import { createAsyncThunk } from '@reduxjs/toolkit';
import type { Nature } from '@/types';
import api from '@/api/client';
import { setNatures, editNature, removeNature } from '../slices/natureSlice';
import { setToast } from '../slices/toastSlice';

export const fetchNatures = createAsyncThunk('nature/fetch', async (_, { dispatch, rejectWithValue }) => {
  try {
    const { data } = await api.get<{ data: Nature[] }>('/natures');
    dispatch(setNatures(data.data ?? []));
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : 'Erreur chargement natures';
    dispatch(setToast({ message, severity: 'error' }));
    return rejectWithValue(message);
  }
});

export const createNature = createAsyncThunk<boolean, Partial<Nature>, { rejectValue: string }>(
  'nature/create',
  async (nature, { dispatch, rejectWithValue }) => {
    try {
      await api.post('/natures', nature);
      await dispatch(fetchNatures());
      dispatch(setToast({ message: 'Nature créée', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur création';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);

export const updateNature = createAsyncThunk<boolean, Nature, { rejectValue: string }>(
  'nature/update',
  async (nature, { dispatch, rejectWithValue }) => {
    try {
      await api.put(`/natures/${nature.id}`, nature);
      dispatch(editNature(nature));
      dispatch(setToast({ message: 'Nature modifiée', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur modification';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);

export const deleteNature = createAsyncThunk<boolean, Nature, { rejectValue: string }>(
  'nature/delete',
  async (nature, { dispatch, rejectWithValue }) => {
    try {
      await api.delete(`/natures/${nature.id}`);
      dispatch(removeNature(nature));
      dispatch(setToast({ message: 'Nature supprimée', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur suppression';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);
